/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

if($('body').hasClass('template-search')  || $('body').hasClass('template-collection')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
      var loadingImage;
      pInfScrNode = $('.product-list__inner.grid_view_custom').find('.more');	        
      // removeing this condition && pInfScrNode.css('display') != 'none'
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        pInfScrURL = $('.product-list__inner.grid_view_custom').find('.more a').attr("href");
        $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/0028/9806/7554/files/Spinner-1s-200px.gif?v=1692351513" class="loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            loadingImage = pInfScrNode.clone().empty().append('');
            loadingImage.insertAfter(pInfScrNode);
            pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {
            // remove loading feedback
            pInfScrNode.next().remove();
            var filteredData = $(data).find(".product-list__inner");
            // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
            $('.product-list__inner.grid_view_custom').find('.more').before(filteredData.html());
            $('.product-list__inner.grid_view_custom').find('.more:not(:last-child)').remove();
            if(filteredData.find('.more').length > 0){
              $('.product-list__inner.grid_view_custom').find('.more').html(filteredData.find('.more').html());
            }else{
              $('.product-list__inner.grid_view_custom').find('.more').remove();
            }
            
            
            loadingImage.remove();	              
            $('.product-list').find('.loading').remove();
            pInfScrLoading = false;
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          },
          dataType: "html"
        });
      }
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
        pInfScrDelay = 20;
      }
    });
  });
}

$(document).ready(function() {

  $(".moa_item_link_btn").on('click', function() {
    $("html").addClass("lock-all");
    $(this).closest(".moa_item_image_inr").siblings(".moa_modal_wrap").addClass('model-open');
  }); 
  $(".moa_modal_cls_btn, .moa_modal_bg-overlay").click(function(){
    $("html").removeClass("lock-all");
    $(".moa_modal_wrap").removeClass('model-open');
  });

  var currentUrl = window.location.href;
  var oldParam = 'return_url=%2Faccount';
  var newParam = 'return_to=/collections/offline-swatch';

  if (currentUrl.includes(oldParam)) {
      var newUrl = currentUrl.replace(oldParam, newParam);
      window.location.href = newUrl; // Redirect to the updated URL
  }

  // js/helper/currency.js
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart    
    console.log(cart);
    $('[data-product-add-to-cart-button]').removeAttr('disabled');
    $('.stockerr_msg').remove();
    var addedqty = 0;
    var cnnnt = 0;
    $(cart.items).each(function(i,e){          
      if(e['product_type'] == 'Fabric Swatch'){
        cnnnt += 1;
        addedqty += e['quantity'];      
      }
    });
    if(cnnnt > 0){
     var restqty = 5 - addedqty;
     $('.product-form [name="quantity"]').attr('data-limit',restqty); 
     if(restqty == 0){       
       $('[data-product-add-to-cart-button],.product-item.hasfabricitem .product-item__cta,.floating_btn_custom').attr('disabled','disabled');
       if($('.product [data-product-add-to-cart-button]').length > 0){
        $('.product [data-product-add-to-cart-button]').closest('form').after('<p class="stockerr_msg">You have added max quantities</p>'); 
       }       
       $('.product-form [name="quantity"]').val(1);
     }else{
       $('.product-form [name="quantity"]').attr('data-limit',restqty);        
       $('[data-product-add-to-cart-button],.product-item.hasfabricitem .product-item__cta,.floating_btn_custom').removeAttr('disabled');
       $('.stockerr_msg').remove();
     }     
    }    
    
  });

  if($('.length_width_wp').length > 0){
   $('body').on('change','.length_width_wp #length', function(){    
      var selectedqty = $(this).find('option:selected').attr('data-qty');
      $('[name="properties[Length]"]').val(selectedqty);
      // let productPrices = document.querySelector("[data-product-price-list]");
      // if (!productPrices) {
      //   return;
      // }
      // console.log(selectedqty);
      // var currentprice = parseInt($('[data-product-price-list]').attr('data-currentprice')) * parseInt(selectedqty);
      // var currentcompprice = parseInt($('[data-product-price-list]').attr('data-currentcompprice')) * parseInt(selectedqty);
      // productPrices.innerHTML = "";
      // if (currentcompprice > currentprice) {
      //   productPrices.innerHTML += `<span class="price price--highlight price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(currentprice, currencyFormat)}</span>`;
      //   productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(currentcompprice, currencyFormat)}</span>`;
      // } else {
      //   productPrices.innerHTML += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(currentprice, currencyFormat)}</span>`;
      // }
      // productPrices.innerHTML += `<span class="per_yard_text">per yard</span>`;
    }); 
  }  

  $('.seo-read-more-less_link').click(function(e){
    e.preventDefault();
    if($(this).closest('.section').find('.content-box').hasClass('active')){
      $(this).text('Read More').closest('.section').find('.content-box').removeClass('active');
    }else{
      $(this).text('Read Less').closest('.section').find('.content-box').addClass('active');
    }
  });


  $('body').on('click','#pincode_submit', function(){    
    var pincodejson = JSON.parse($('#pincodeData').html());
    if(pincodejson){
      function findPincodeBlock(pincode) {
        var foundBlock = null;

        $.each(pincodejson.groups, function(index, group) {
            var pincodesArray = group.pincodes.split(","); // Convert string to array
            if (pincodesArray.includes(pincode)) {
                foundBlock = group;
                return false; // Break the loop
            }
        });

        return foundBlock;
      }
      var inputPincode = $(this).closest('.checker_widget').find("#pincode_input").val().trim();
      var result = findPincodeBlock(inputPincode);

      if (result) {
          $(this).closest('.checker_widget').find('.message').addClass('success').removeClass('error').text(result.message);
      } else {
          $(this).closest('.checker_widget').find('.message').removeClass('success').addClass('error').text($(this).closest('.checker_widget').find('.message').attr('data-errmsg'));
      }
      
    }
    console.log(pincodejson);
  });

  $('body').on('click','[data-copybutton]',function() {
    const tempInput = $('<input>');
    $('body').append(tempInput);

    // Change the value below to the link or text you want to copy
    const textToCopy = $(this).attr('data-copylink');

    tempInput.val(textToCopy).select();
    document.execCommand('copy');
    tempInput.remove();
    $('.share-model-popup,.model_overlay').removeClass('active');
    $('body').removeClass('lock-all');
  });

  $('body').on('click','.share-button-custom',function(){
    $('.share-model-popup,.model_overlay').addClass('active');
    $('body').addClass('lock-all');
  });
  $('body').on('click','.share-model-popup .modal__close-button',function(){
    $('.share-model-popup,.model_overlay').removeClass('active');
    $('body').removeClass('lock-all');
  });

  if($('.filter_main_content').length > 0){
     // var collhandle = $('.filter_main_content').attr('data-collection');
     // $.get(`/collections/${collhandle}?view=get_filters`, function( data ) {
     //  $('.filter_main_content').html($(data).find('.facet-filters-fetch').html());
     // });

    var currentURL;
    $('body').on('click','.facet-filters-form .checkbox-container input[type="checkbox"],.facet-filters-form .color-swatch  input[type="checkbox"]',function(e){
      e.preventDefault();
      var _this = $(this);
      var href = $(this).attr('name');
      var val = $(this).attr('value');
      if(val != undefined && val != ''){
        if(val.indexOf(' ') >= 0){
          val = val.replaceAll(' ','+').replaceAll('&','%26');
        }
        if(val.indexOf('&') >= 0){
          val = val.replaceAll('&','%26');
        }
        currentURL = window.location.href;
        var finalVAL = href+'='+val;
        var is_current = false;
        var without_cur = [];
        var params = {};
        var parser = document.createElement('a');
        parser.href = window.location.href;
        var query = parser.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split('=');        
          if(encodeURI(href) == pair[0] && val == pair[1]){
            is_current = true;
          }else if(encodeURI(href) == pair[0] && val == 'none'){
            is_current = true;
          }else{
            if(_this.closest('.facet-filters-form').hasClass('single_value')){
              if(encodeURI(href) == pair[0]){
               without_cur.push(pair[0] + '=' + val);    
              }else{
               without_cur.push(pair[0] + '=' + pair[1]);    
              }
            }else{
             without_cur.push(pair[0] + '=' + pair[1]); 
            }          
          }
        }
        
        if(is_current){  
          currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
          
          if(without_cur.length > 0){
            currentURL = currentURL + '?' +without_cur.join('&')
          }else{              
            currentURL = currentURL;
          }            
        }else{
          if(_this.closest('.facet-filters-form').hasClass('single_value') && currentURL.indexOf(href) > -1){
            var newurl = [];
            currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
            for (var i = 0; i < vars.length; i++) {
              var pair = vars[i].split('=');        
              if(encodeURI(href) == pair[0]){
                newurl.push(finalVAL);
              }else{                
                newurl.push(pair[0] + '=' + pair[1]);                 
              }
            }
            if(currentURL.indexOf('?') >= 0){
              currentURL = currentURL + '&' + newurl.join('&');
            }else{
              currentURL = currentURL + '?' + newurl.join('&');
            }
          }else{
            if(val != 'none'){
              if(currentURL.indexOf('?') >= 0){
                currentURL = currentURL + '&' + finalVAL;
              }else{
                currentURL = currentURL + '?' + finalVAL;
              }    
            }
          }        
        }  
        if(currentURL.indexOf('?') == -1){
          currentURL = currentURL+'?view=filter_form';
        }
        history.replaceState({}, "", currentURL);
        triggerEvent(document.documentElement, "theme:loading:start");
        const url = new URL(window.location);
        // url.searchParams.set("section_id", this.getAttribute("section-id"));
        $.get(currentURL, function( data ) {
          const fakeDiv = document.createElement("div");
          fakeDiv.innerHTML = data;
          _this.closest('#facet-filters-form').html(fakeDiv.querySelector("#facet-filters-form").innerHTML);
          triggerEvent(document.documentElement, "theme:loading:end");
        });
        
        
      }
    });

    $('body').on('click','.filter_submit_btn', function(){
      var currentURL = $(this).attr('data-colurl');
      var cnnt = 0;
      $(this).closest('.product-facet__filters').find('.product-facet__filter-item').each(function(i,e){
        if($(this).find('input[type="checkbox"]:checked').length > 0 && $(this).find('input[type="checkbox"]:checked').val() != 'none'){
          cnnt += 1;
          var href = $(this).find('input[type="checkbox"]:checked').attr('name');
          var val = $(this).find('input[type="checkbox"]:checked').attr('value');
          if(val.indexOf(' ') >= 0){
            val = val.replaceAll(' ','+').replaceAll('&','%26');
          }
          if(val.indexOf('&') >= 0){
            val = val.replaceAll('&','%26');
          }
          
          if(val.indexOf('/') >= 0){
            val = val.replaceAll('/','%2F');
          }
          var finalVAL = href+'='+val;
          if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + finalVAL;
          }else{
            currentURL = currentURL + '?' + finalVAL;
          } 
        }        
      });
      window.location.href = currentURL;
      console.log(currentURL);
    });
  }
  
  $('body').on('click','.additional_item .additional_atc', function(){
    var submitButtons = $(this);    
    submitButtons.attr("disabled", "disabled");
    submitButtons.attr("aria-busy", "true");
    var vid = $(this).attr('data-vpid');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: vid,
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy");        
      },
      success: function(data){
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy");        
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          // cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: true
            }
          }));
          // document.getElementById('mini-cart').open = true;
        });
      }
    });
  });  

    function scrollToSection(event) {
    var width = $(window).outerWidth();
    event.preventDefault();
    $(".product-tab-iner a").removeClass("active");
    $(this).addClass("active");
    var $section = $($(this).attr("href"));
    if(width>=999){
       $("html, body").animate(
        {
          scrollTop: $section.offset().top - 102,      
        },
        500
      ); 
    } else {
      $("html, body").animate(
        {
          scrollTop: $section.offset().top - 0,      
        },
        500
      );
    }   
  }
  $(".ptb_link").on("click", scrollToSection);

  //set cookie
  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
      
  $('body').on('click','.ctryModal-Content .stay_here_button', function(){
    $(".ctryModal-Content-overlay").removeClass('active');
    $(".ctryModal-Content").removeClass('active');
    $("body").removeClass('overflow-hidden');
    setCookie('redirectchoice',true,30);
  });

  $(window).scroll(function() {
    var scrollDistance = $(window).scrollTop() + 200;    
    $('.page-section').each(function(i) {
      if ($(this).position().top <= scrollDistance) {
        $('.product-tab-row a.active').removeClass('active');
        $('.product-tab-row a').eq(i).addClass('active');
      }
    });
  }).scroll();

  $('.section_accordion_button_heading').click(function(){
    $(this).toggleClass('active');
    $(this).next('.section_accordion_content').slideToggle();
  });

   $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });
  $("body").on("click", ".product-offer-code-block", function () {
    var copy_text = $(this).find('.product-offer-copy-code');
    var text = $(this).find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  $("body").on('change', '.size-chart_toggle-item_radio', function() {
    if ($(this).val() === "inch") {
        // Show Inch table and hide Cm table
        $('.size-chart-table-inch').show();
        $('.size-chart-table-cm').hide();
    } else if ($(this).val() === "cm") {
        // Show Cm table and hide Inch table
        $('.size-chart-table-cm').show();
        $('.size-chart-table-inch').hide();
    }
  });
  $('#size-chart_toggle-item_radio-1','#size-chart_toggle-item_radio-11').click()

  // GIFTING PRODUCT
  $('body').on('change','.gifting_product_content #input-checkbox-product', function(){
    var mainprice = parseInt($('.product__info [data-product-price-list]').attr('data-currentprice'));
    var compareprice = parseInt($('.product__info [data-product-price-list]').attr('data-currentcompprice'));
    var prddta = JSON.parse($('.gifting_product_content').find('#extra_product').html());
    var vprice = prddta.product.variants[0].price;   
    console.log('vprice',vprice);
    console.log('prddta',prddta);
    var pricehtml = "";
    if($(this).is(':checked')){
      if (compareprice > mainprice) {
        pricehtml += `<span class="price price--highlight price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice + vprice, currencyFormat)}</span>`;
        pricehtml += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(compareprice + vprice, currencyFormat)}</span>`;
      } else {
          pricehtml += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice + vprice, currencyFormat)}</span>`;
        }
    }else{
      if (compareprice > mainprice) {
        pricehtml += `<span class="price price--highlight price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice, currencyFormat)}</span>`;
        pricehtml += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(compareprice, currencyFormat)}</span></span>`;
      } else {
        pricehtml += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice, currencyFormat)}</span>`;
      }
    }
    $(this).closest('.product__info').find('[data-product-price-list]').html(pricehtml);
  })

  $('body').on('click', '.pswp__button--close', function() {
    console.log($(this).closest('.product__media').find('product-image-zoom'))
    // $(this).closest('.product__media').find('product-image-zoom').removeClass('.pswp--open');
    setTimeout(() => {
        $(this).closest('.product__media').find('product-image-zoom').removeClass('.pswp--open');
    }, 2000); // Adjust the delay (in milliseconds) as needed, e.g., 500ms
  });

  // $('.pro-content-use-care-list').slick({
  //   dots: true,
  //   arrows: false,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 999,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 740,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true
  //       }
  //     }
  //   ]
  // })

  $(".collection-detail__media-wrap").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: '<svg focusable="false" width="15" height="12" class="slick-prev" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>',
    nextArrow: '<svg focusable="false" width="15" height="12" class="slick-next" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>',
  }); 
  
   $(".customer-testimonial_wrap").slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  }); 

  $(".offline-product-images").slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1
  }); 

  $(".opdps-slider").slick({
    dots: false,
    arrows: true,
    slidesToShow: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          arrows: false
        }
      }
    ]
  });

  $(".home-done-slider").slick({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        slidesToShow: 2
      },
      {
        breakpoint: 1000,
        settings: 'unslick'
      }
    ]
  });

  $(".review-section-slider").slick({
    dots: true,
    arrows: false,
    slidesToShow: 3,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: 'unslick'
      }
    ]
  });

  $(".testimonial-third-list").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,    
    slidesToScroll: 1,
    prevArrow: '<svg focusable="false" width="15" height="12" class="slick-prev" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>',
    nextArrow: '<svg focusable="false" width="15" height="12" class="slick-next" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>',
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

  const $slider = $('.custom-slideshow__slide-list');

  $slider.slick({
    fade: true,
    cssEase: 'linear',
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    swipe: true,
    infinite: true,
    swipeToSlide: true,
    adaptiveHeight: true,
    pauseOnHover: false
  });

  if($slider.length > 0){
    function handleSlideChange(currentSlide) {
      const $currentSlide = $slider.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
      const isMobile = window.matchMedia('(max-width: 999px)').matches;
    
      const $visibleVideoWrapper = $currentSlide.find('.slideshow__image-wrapper').filter(function () {
        const hasHiddenPocket = $(this).hasClass('hidden-lap-and-up');
        const hasHiddenLap = $(this).hasClass('hidden-pocket');
        return (isMobile && !hasHiddenLap) || (!isMobile && !hasHiddenPocket);
      });
    
      const $video = $visibleVideoWrapper.find('video');
      const videoElement = $video.get(0);
    
      const $dots = $('.custom-slideshow__slide-list .slick-dots li');
      $dots.find('button').css('animation', 'none');
    
      // Pause all other videos
      $slider.find('video').each(function () {
        this.pause();
        this.currentTime = 0;
      });
    
      // Check if this slide has a visible video
      if (videoElement) {
        $slider.slick('slickPause');
    
        videoElement.muted = true;
        videoElement.playsInline = true;
    
        const playVideo = () => {
          const duration = videoElement.duration || 4.5;
          setDotAnimationDuration(duration);
  
          console.log(videoElement)
          videoElement
            .play()
            .then(() => {
              console.log('🎬 Video autoplay started');
            })
            .catch(err => {
              console.warn('⚠️ Video autoplay failed:', err);
              $slider.slick('slickPlay');
              setDotAnimationDuration(4.5);
            });
        };
    
        if (videoElement.readyState >= 1) {
          playVideo(); // metadata is already available
        } else {
          videoElement.onloadedmetadata = playVideo; // wait for metadata
        }
    
        videoElement.onended = function () {
          console.log('🎥 Video ended');
          $slider.slick('slickNext');
          $slider.slick('slickPlay');
        };
      } else {
        // It's an image slide
        console.log('🖼️ No video. Start image autoplay');
        $slider.slick('slickPlay');
        setDotAnimationDuration(4.5);
      }
    }
  
  
    
     function setDotAnimationDuration(seconds) {
      const $activeDotBtn = $('.slideshow-custom .slick-dots li.slick-active button');
      
      // Reset animation by removing and forcing reflow
      $activeDotBtn.css('animation', 'none');
      void $activeDotBtn[0].offsetWidth; // trigger reflow
    
      $activeDotBtn.css('--dot-animation-duration', `${seconds}s`);
    }
  
  
    // Initial check
    handleSlideChange(0);
  
    // On after slide change
    $slider.on('afterChange', function (event, slick, currentSlide) {
      handleSlideChange(currentSlide);
    });
  }

  $('body').on('click','.rm-content-text',function(e) {
    e.preventDefault();
    // $(this).closest('collapsible-content').find('.collapsible__content').toggleClass('active');
    $(this).closest('collapsible-content').find('.hasmore').each(function() {
      $(this).slideToggle();
    });
    if ($(this).text() == "See more") {
      $(this).text("See less")
    } else {
      $(this).text("See more")
    }
  });

  $('body').on('click','.offline-product-designs-image', function(){
    $('body').addClass('offline-product-design-popup-open');
    $(this).closest('.offline-product-wrapper').find('.offline-product-design-popup-slider').addClass('active');
    var slideno = $(this).data('slide');
    $('.opdps-slider').slick('slickGoTo', slideno - 1);
  });
  $('body').on('click','.opdps-close-btn', function(){
    $('body').removeClass('offline-product-design-popup-open');
    $(this).closest('.offline-product-design-popup-slider').removeClass('active');
  });

  $('.video-slider-video-blocks').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  $('.video-slider-cover-images').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });
  //   $('.video-slider-cover-videos').slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   dots: false,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 999,
  //       settings: {
  //         slidesToShow: 3,
  //       }
  //     },
  //     {
  //       breakpoint: 740,
  //       settings: {
  //         slidesToShow: 1,
  //         arrows: false,
  //         dots: true
  //       }
  //     }
  //   ]
  // });
  
  $('.trending-image-slider-blocks').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '80px',
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0',
          arrows: false,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  $(".trending-image-slider-blocks").on("beforeChange", function(event, slick, currentSlide, nextSlide){
    $("trending-image-slider-blocks .slick-dots li").removeClass("slick-active");
    $(".trending-image-slider-blocks .slick-dots li button").attr("aria-pressed","false").focus(function() {
            this.blur();
    });
  });

  $('body').on('click', '.video-slider-cover', function (e) {
    e.stopPropagation();
    var $item = $(this).closest('.video-slider-video-item');
    var video = $item.find('video')[0];

    $item.addClass('is-playing');
    video.play().catch(function (err) {
      console.log('Play prevented:', err);
    });
  });

  $('body').on('click','.video-slider-cover-image, .video-slider-video-item', function(){
    $('html').addClass('no-scroll');
   $(this).closest('.video-slider-inner').find('.video-slider-video-wrap').addClass('active');
   let slideno = $(this).data('slide') - 1;
   $(this).closest('.video-slider-inner').find('.video-slider-video-blocks').slick('slickGoTo', slideno);

      const video = $(this).closest('.video-slider-inner').find('.video-slider-video-blocks .video-slider-video-block.slick-slide.slick-current.slick-active').find('video')[0];
      video.currentTime = 0;   // restart from beginning
      video.muted = false;
      video.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
 });

 $('.video-slider-video-blocks').on('init afterChange', function(event, slick, currentSlide){
    var current = currentSlide || 0;
    console.log('current',current);
    var slidevideo = $(this).find('.slick-slide[data-slick-index="' + (current) + '"] video')[0];
    slidevideo.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    var prevVideo = $(this).find('.slick-slide[data-slick-index="' + (current - 1) + '"] video')[0];
    if (prevVideo) {
        prevVideo.pause();
        prevVideo.currentTime = 0;
    }
    var nextVideo = $(this).find('.slick-slide[data-slick-index="' + (current + 1) + '"] video')[0];
    if (nextVideo) {
        nextVideo.pause();
        nextVideo.currentTime = 0;
    }
 })

  $('body').on('click', '.video-slider-close-button', function () {
    $('.video-slider-video-wrap').removeClass('active');
    $('html').removeClass('no-scroll');

    $('.video-slider-video-blocks video').each(function () {
      this.pause();
    });

    $('.video-slider-video-item.has-cover.is-playing').removeClass('is-playing').find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });
  });
  
})

$('body').on('click', '.product-media_item__zoom-button', function() {
  $('.product__media-item').removeClass('is-initial-selected');
  $('.product__media-item').removeClass('is-selected');
  $(this).parents('.product__media-item').addClass('is-selected');
  $(this).parents('.product__media').find('.product__zoom-button').trigger('click');
});

let actionlink = '';
document.addEventListener("DOMContentLoaded", () => {

  function runPincodeCheck(inputEl) {
    var validPincodes = window.themeVariables.settings.servicable_pincode;
    validPincodes = validPincodes.replace(' ,', ',').replace(', ', ',').split(',');

    $('.pincode_err_msg, .pincode_success_msg').remove();

    const enteredPincode = inputEl.value.trim();
    if (enteredPincode.length === 6) {
      if (validPincodes.includes(enteredPincode)) {
        $(inputEl).after(`<p class="pincode_success_msg">${window.themeVariables.settings.pincode_success_msg}</p>`);
        $(inputEl).closest('.cs-form-wrap')
          .attr('action', actionlink)
          .find('.form-submit-btn-wrap [type="submit"]')
          .removeAttr('disabled')
          .removeClass('noclick');
      } else {
        if (actionlink === '') {
          actionlink = $(inputEl).closest('.cs-form-wrap').attr('action');
        }
        $(inputEl).after(`<p class="pincode_err_msg">${window.themeVariables.settings.pincode_err_msg}</p>`);
        $(inputEl).closest('.cs-form-wrap')
          .attr('action', '')
          .find('.form-submit-btn-wrap [type="submit"]')
          .attr('disabled', 'disabled')
          .addClass('noclick');
      }
    } else {
      if (actionlink === '') {
        actionlink = $(inputEl).closest('.cs-form-wrap').attr('action');
      }
      $(inputEl).after('<p class="pincode_err_msg">Please add a valid pincode.</p>');
      $(inputEl).closest('.cs-form-wrap')
          .attr('action', '')
          .find('.form-submit-btn-wrap [type="submit"]')
          .attr('disabled', 'disabled')
          .addClass('noclick');
    }
  }

  // <-- Shopify-safe event delegation
  $(document).on('input', '#Pincode', function () {
    runPincodeCheck(this);
  });

  $('body').on('click', '.india-curtain-home-visit .only-buttons-list_item .only-buttons-list_item-button', function () {
    const target = $(this).attr('href');

    if ($(target).length) {
      $('html, body').animate({
        scrollTop: $(target).offset().top
      }, 600);
    }
  });

  $('body').on('click', '.home-visit-form-button', function () {
    const target = $(this).attr('href');
    console.log('target',target);
    if ($(target).length) {
      $('html, body').animate({
        scrollTop: $(target).offset().top - 100
      }, 200);
    }
  });

  $('body').on('click', '.pwp-button', function () {
    const target = $(this).attr('href');
    console.log('target',target);
    if ($(target).length) {
      $('html, body').animate({
        scrollTop: $(target).offset().top - 100
      }, 200);
    }
  });

  $('.image-text-slider-blocks').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    mobileFirst: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: 'unslick'
      }
    ]
  }); 
  $('.itsbm-modal-blocks').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg width="19" height="28" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7722 14.61L4.591 0.506316C4.28613 0.179852 3.87916 0 3.44522 0C3.01128 0 2.60431 0.179852 2.29944 0.506316L1.32874 1.54472C0.69709 2.22135 0.69709 3.32107 1.32874 3.99668L12.3973 15.8401L1.31645 27.6967C1.01159 28.0231 0.843262 28.4583 0.843262 28.9224C0.843262 29.3869 1.01159 29.8221 1.31645 30.1489L2.28716 31.187C2.59227 31.5135 2.999 31.6933 3.43294 31.6933C3.86688 31.6933 4.27385 31.5135 4.57871 31.187L17.7722 17.0705C18.0778 16.743 18.2457 16.3057 18.2447 15.8409C18.2457 15.3742 18.0778 14.9372 17.7722 14.61Z" fill="#000"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="19" height="28" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7722 14.61L4.591 0.506316C4.28613 0.179852 3.87916 0 3.44522 0C3.01128 0 2.60431 0.179852 2.29944 0.506316L1.32874 1.54472C0.69709 2.22135 0.69709 3.32107 1.32874 3.99668L12.3973 15.8401L1.31645 27.6967C1.01159 28.0231 0.843262 28.4583 0.843262 28.9224C0.843262 29.3869 1.01159 29.8221 1.31645 30.1489L2.28716 31.187C2.59227 31.5135 2.999 31.6933 3.43294 31.6933C3.86688 31.6933 4.27385 31.5135 4.57871 31.187L17.7722 17.0705C18.0778 16.743 18.2457 16.3057 18.2447 15.8409C18.2457 15.3742 18.0778 14.9372 17.7722 14.61Z" fill="#000"/></svg></button>',
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  $('.image-text-slider-block').click(function(e) {
     e.preventDefault();
     var slideno = $(this).data('slide');
     console.log('var',slideno)
     $('.itsbm-modal-blocks').slick('slickGoTo', slideno - 1);
   });

  $(".image-text-slider-block").on('click', function() {
    $(this).closest(".image-text-slider-wrap").siblings(".image-text-slider-modal").addClass('model-open');
  }); 

  $(".itsbm_modal_cls_btn, .itsbm-overlay").click(function(){
    $(".image-text-slider-modal").removeClass('model-open');
  });

  $('body').on('click', '.vsci-read-more', function () {
    var $button = $(this);
    var $text = $button.closest('.vsci-text');

    $text.toggleClass('active');

    if ($text.hasClass('active')) {
      $button.text('Read less');
    } else {
      $button.text('Read more');
    }
  });

});

$(function () {
  if (!document.body.classList.contains('template-page-stores')) return;

  const $blocks = $('.store-locator-hero-block');
  const $cards = $('.exp-card');
  const $count = $('.exp-scroller');
  const $faqs = $('.faq__item');
  if (!$blocks.length) return;

  function updateCardCount() {
    const visibleCards = $('.exp-scroller .exp-card:not(.is-filtered-out)').length;

    $count
      .removeClass('cards-1 cards-2 cards-3 cards-4 cards-5-plus')
      .addClass('cards-' + visibleCards);
  }

  $('body').on('click', '.store-locator-hero-block', function () {
    const $block = $(this);
    const city = ($block.attr('data-city') || '').trim().toLowerCase();
    const wasActive = $block.hasClass('is-active');

    $blocks.removeClass('is-active');
    $cards.removeClass('is-filtered-out');
    $faqs.removeClass('is-filtered-out');

    if (wasActive) {
      updateCardCount();
      return;
    }

    $block.addClass('is-active');

    $cards.each(function () {
      const card = ($(this).attr('data-card') || '').trim().toLowerCase();
      if (card !== city) $(this).addClass('is-filtered-out');
    });

    $faqs.each(function () {
      const faq = ($(this).attr('data-faq') || '').trim().toLowerCase();
      if (faq !== city) $(this).addClass('is-filtered-out');
    });
    updateCardCount();
  });
  // Initial count
  updateCardCount();
});